module.exports = __webpack_public_path__ + "img/AXIS Logo for Dark Backgrounds - Grayscale.a183b9e7.png";